<template>
  <div>
    <div style="background-color: #ffffff;">
      <div style="overflow-x: auto;padding: 16px;">
        <div :style="{width:list.length*100+'px'}">
          <div v-for="(item,i) in list" :key="i" @click="goAnchor(i)" class="inline-block pointer"
               style="width: 80px;overflow: hidden;border: none;" :style="currentIndex==i?'color:#409EFF;':''">
            <div class="nowrap-1">{{item.categoryName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div ref="anchor" style="height: calc(100vh - 200px);overflow-y: auto;">
      <div v-for="(item,i) in list" :key="i" :id="'anchor-'+i" style="border-radius: 10px;margin: 16px;border: solid 1px #D2D5E4;">
        <div class="flex-middle" style="height: 52px;border-top-left-radius: 10px;border-top-right-radius: 10px;background-color: #E2E2E2;">
          <div class="nowrap-1" style="font-weight: bold;padding-left: 21px;">{{item.categoryName}}</div>
        </div>
        <div style="padding: 0 16px;">
          <div v-for="(jtem,j) in item.specialtyList" :key="j" class="text-center" :style="j<item.specialtyList.length-1?'border-right: solid 1px #E5E5E5;':''"
               style="padding: 0 10px;margin-bottom:16px;">
            {{jtem.specialtyName}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'anchor',
  props: ['list2'],
  components: {},
  data () {
    return {
      currentIndex: 0,
      list: [
        { categoryName: '器乐类1', categoryId: '1', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类2', categoryId: '2', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类3', categoryId: '3', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类4', categoryId: '4', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类5', categoryId: '5', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] },
        { categoryName: '器乐类6', categoryId: '6', specialtyList: [{ specialtyName: '钢琴1' }, { specialtyName: '钢琴2' }, { specialtyName: '钢琴3' }, { specialtyName: '钢琴4' }] }
      ]
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    goAnchor (i) {
      this.currentIndex = i
      this.$refs['anchor'].scrollTop = window.document.getElementById('anchor-' + i).offsetTop - 100
    }
  }
}
</script>
<style>
</style>
